var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.checkAcessoCredor)?_c('iframe',{staticStyle:{"width":"100%","height":"80vh"},attrs:{"src":_vm.powerBi,"frameborder":"0"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }